<app-function-bar>
  @if (addNewRouterLink && canAddNew) {
    <a class="tu-button primary tu-shadow ms-auto" [routerLink]="addNewRouterLink" [state]="addNewRouterState">
      {{ 'content.item-list.add-new' | translate }}
    </a>
  }
</app-function-bar>
<form class="row" [formGroup]="filterForm" (ngSubmit)="submit(filterForm.value)">
  <div class="form-group col-md-2 ms-3 me-2">
    <label for="filter-users-input-{{ inputId }}" class="visually-hidden">{{ (searchMode === 'manual' ? 'content.search' : 'content.item-list.filter') | translate }}:</label>
    <input id="filter-users-input-{{ inputId }}" class="form-control" type="text" autocomplete="on" formControlName="value" placeholder="{{ filterFormPlaceholder }}">
  </div>
  <div class="col-auto me-2">
    <button class="tu-button primary tu-shadow" type="submit">{{ (searchMode === 'manual' ? 'content.search' : 'content.item-list.filter') | translate }}</button>
  </div>
  <div class="col-auto">
    @if (filterForm.getRawValue().value || itemsList?.length > 0) {
      <button
        class="tu-button secondary tu-shadow" type="button"
      (click)="resetFilter();">{{ 'content.reset' | translate }}</button>
    }
  </div>
</form>
<ng-content></ng-content>
@if (itemsList?.length === 0) {
  <div>{{ 'content.no-results-found' | translate }}</div>
}
